import { useState, useEffect, useCallback, useRef } from 'react';
import {
  getHeadersUnwrapped,
  searchRequest,
  useUserContext,
  IApiCallStatus,
  IError,
} from '../common';
import { IRequestStatus } from '.';
import { fold } from 'fp-ts/lib/Either';
import { flow } from 'fp-ts/function';

export const useRequestSearch = ({
  page,
  pageSize,
  sortBy,
  sortDirection,
  searchBy,
  searchP1,
  searchP2,
  di,
  requestorEmail,
  legacy,
}: {
  page: number;
  pageSize: number;
  sortBy: string;
  sortDirection: string;
  searchBy: string;
  searchP1: string;
  searchP2: string;
  di: boolean;
  requestorEmail: string;
  legacy: boolean | undefined | null;
}) => {
  const { user } = useUserContext();
  const [requestStatus, setRequestStatus] = useState<{
    totalElements: number;
    content: IRequestStatus[];
  }>({ totalElements: 0, content: [] });

  const [call, setCall] = useState<IApiCallStatus>();

  const paramsRef = useRef({
    page, pageSize, sortBy, sortDirection, searchBy, searchP1, searchP2, di, requestorEmail, user,
  });
  useEffect(() => {
    paramsRef.current = {
      page, pageSize, sortBy, sortDirection, searchBy, searchP1, searchP2, di, requestorEmail, user,
    };
  });

  // const [searchTrigger, setSearchTrigger] = useState(0);

  useEffect(() => {
    if (call !== null) return;
    const p = paramsRef.current;
    flow(
      getHeadersUnwrapped,
      searchRequest
    )(p.user)({
      page: p.page, pageSize: p.pageSize, sortBy: p.sortBy, sortDirection: p.sortDirection,
      searchBy: p.searchBy, searchP1: p.searchP1, searchP2: p.searchP2, di: p.di, requestorEmail: p.requestorEmail, legacy
    }).then(
      fold<IError, { totalElements: number; content: IRequestStatus[] }, void>(
        flow(
          e => setRequestStatus({ totalElements: 0, content: [] }),
          () => setCall(false)
        ),
        flow(setRequestStatus, () => setCall(true))
      )
    );
  }, [
 call
  ]);

  const search = useCallback(() => setCall(null), []);
  return { requestStatus, call, search };


};
